import { StyledDisplay } from '@components/Text';
import { LabelColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { BorderBottom } from '@pages/Main/Common/Banner/Banner.style';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import { CategoryButton, CategoryButtonWrapper, LogoBox, LogoWrapper } from './Customers.style';
import { StyledGridContainer } from '@components/Grid/Grid.style';
import { DivAllCenter } from '@pages/CommonStyle/commonDiv.style';
import * as Images from '@src/assets/images/main/customers/index'; // on/off 이미지 import된 파일
import { ScreenViewButtonWrapper } from '@pages/Main/Common/ScreenVIew/ScreenView.style';

const CATEGORY_KEYS = ['all', 'manufacture', 'construction', 'public', 'healthcare', 'it'];

const CATEGORY_MAP = {
  manufacture: ['hd', 'hyundai', 'cj', 'il', 'threem', 'oci', 'hdmipo', 'kia', 'solum', 'autoever', 'autoplus', 'carro', 'corning', 'lgelectric', 'everdigm'],
  construction: ['ex', 'chungam', 'hanwha', 'gs', 'koreajosun', 'busan', 'samsung2', 'posco', 'whanki'],
  public: ['koreaenv', 'kra', 'koreaindustry', 'seoul', 'fire', 'seoulcity', 'seoulsisul', 'krwa', 'kepc', 'koreatech', 'keti', 'etri'],
  healthcare: ['ajouhospital', 'ajou', 'keimyung', 'ujung', 'osstem'],
  it: ['samsung', 'cheil', 'sk', 'kakao', 'coupang', 'banksalad', 'fourtytwo', 'skshielders', 'yanolja', 'riskzero', 'skaichips', 'dmuseum', 'postech'],
};

const LOGO_ORDER = [
  'hd',
  'hyundai',
  'seoulcity',
  'cheil',
  'krwa',
  'samsung',
  'solum',
  'koreaenv',
  'sk',
  'corning',
  'ex',
  'ajouhospital',
  'posco',
  'lg',
  'cj',
  'hdmipo',
  'il',
  'busan',
  'lgelectric',
  'samsung2',
  'chungam',
  'kakao',
  'everdigm',
  'koreasafety',
  'postech',
  'kepc',
  'seoulcity',
  'banksalad',
  'threem',
  'bonghwa',
  'coupang',
  'kia',
  'hyupsung',
  'fourtytwo',
  'ujung',
  'koreatech',
  'xi',
  'autoplus',
  'dmuseum',
  'yanolja',
  'kmu',
  'fire',
  'seoulcity',
  'osstem',
  'oci',
  'gs',
  'keimyung',
  'koreaindustry',
  'keti',
  'hanwha',
  'autoever',
  'whanki',
  'koreajosun',
  'sg',
  'etri',
  'solid',
  'seoulsisul',
  'kra',
  'carro',
  'skshielders',
  'riskzero',
  'nonghyup',
  'skaichips',
  'ajou',
];

const Customers = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedKey = CATEGORY_KEYS[selectedIndex];

  const wrapperRef = useRef<HTMLDivElement>(null);
  const activeRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const wrapper = wrapperRef.current;
    const active = activeRef.current;
    if (!wrapper || !active) return;

    const wrapperRect = wrapper.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();

    // 스크롤해야 할 양 = 현재 버튼의 좌측 위치 - wrapper 기준 왼쪽 + 현재 scrollLeft - 목표 위치(100px)
    const offset = active.offsetLeft - 100;

    wrapper.scrollTo({
      left: offset,
      behavior: 'smooth',
    });
  }, [selectedIndex]);

  // ✅ 자동 전환 타이머
  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedIndex((prev) => (prev + 1) % CATEGORY_KEYS.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // ✅ 활성화 로고 목록 처리
  const isAll = selectedKey === 'all';
  const activeSet = isAll ? new Set(LOGO_ORDER) : new Set(CATEGORY_MAP[selectedKey] ?? []);

  return (
    <StyledGridContainer>
      <DivAllCenter>
        <SpacingDTM d="128" t="96" m="64" />
        <StyledDisplay size="small">
          <Trans i18nKey={`home.customers.title`} />
        </StyledDisplay>
        <Spacing pixel="16" />

        <ScreenViewButtonWrapper ref={wrapperRef}>
          <CategoryButtonWrapper>
            {CATEGORY_KEYS.map((key, i) => {
              const isSelected = i === selectedIndex;
              return (
                <CategoryButton key={i} ref={isSelected ? activeRef : undefined} onClick={() => setSelectedIndex(i)} selected={isSelected}>
                  <LabelColor color={isSelected ? '#000' : '#818181'} size="small">
                    <Trans i18nKey={`home.customers.category.${i}.title`} />
                  </LabelColor>
                </CategoryButton>
              );
            })}
          </CategoryButtonWrapper>
        </ScreenViewButtonWrapper>

        <Spacing pixel="48" />

        <LogoWrapper>
          {LOGO_ORDER.map((key, i) => {
            const isActive = activeSet.has(key);
            const imgSrc = isActive ? Images[`${key}On`] : Images[`${key}Off`];
            return <LogoBox key={i} src={imgSrc} alt={key} />;
          })}
        </LogoWrapper>

        <SpacingDTM d="96" t="96" m="64" />
      </DivAllCenter>
    </StyledGridContainer>
  );
};

export default Customers;
